import { useServices } from 'containers/services';
import { useAppNotifications } from 'hooks';
import type { FindPersonsResult, PersonsFilter } from 'lib/services/personsApi';
import { type UseQueryOptions, type UseQueryResult, useQuery } from 'react-query';
import { getErrorMessage } from 'utils/getErrorMessage';
import { QUERY_KEYS } from 'utils/queryKeys';

export const usePersons = (
  filter: PersonsFilter,
  options: UseQueryOptions<FindPersonsResult> = {},
): UseQueryResult<FindPersonsResult> => {
  const notify = useAppNotifications();
  const { personsApiClient } = useServices();

  return useQuery(
    QUERY_KEYS.persons.filter(filter),
    async ({ signal }) => await personsApiClient.find(filter, signal),
    {
      onError: error =>
        notify.error({
          message: 'There was an error while fetching persons',
          description: getErrorMessage(error),
        }),
      ...options,
    },
  );
};
